import { useMemo } from 'react';
import { useQuery, QueryHookOptions } from '@apollo/client';

import usePagination from './usePagination';
import PROVIDER_OPTIONS_QUERY, {
  ProviderOptionsQueryReturn,
  ProviderOptionsQueryVariables,
} from '@src/graphql/queries/providerOptions';

function useSupplierRelationshipsQuery({
  variables,
  skip,
  fetchPolicy,
}: QueryHookOptions<ProviderOptionsQueryVariables>) {
  const { data, loading, error, refetch } = useQuery<
    ProviderOptionsQueryReturn,
    ProviderOptionsQueryVariables
  >(PROVIDER_OPTIONS_QUERY, {
    variables: {
      businessId: variables?.businessId,
      sortBy: { field: 'CREATED_AT', direction: 'DESC' },
      ...variables,
    },
    skip: skip || !variables?.businessId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: fetchPolicy || 'cache-and-network',
  });

  const { count, hasNext, hasPrevious, next, previous, page } = usePagination(
    data?.providerRelationships,
    refetch,
    variables?.first || variables?.last,
    variables?.page
  );

  const supplierRelationships = useMemo(
    () => data?.providerRelationships?.edges?.map((edge) => edge.node) || [],
    [data]
  );

  return {
    data: supplierRelationships,
    loading: !data && loading,
    error,
    count,
    hasNext,
    hasPrevious,
    next,
    previous,
    page,
    refetch,
  };
}

export default useSupplierRelationshipsQuery;
